import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetConfiguracaoCampoObrigatorioResponse } from '../../responses/financas/configuracao-campo-obrigatorio.response';
import { ConfiguracaoCampoObrigatorioRequest } from '../../requests/financas/configuracao-campo-obrigatorio.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class ConfiguracaoCampoObrigatorioService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'ConfiguracaoCampoObrigatorio';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(): Observable<GetConfiguracaoCampoObrigatorioResponse> {
        return this.httpClient
            .get<GetConfiguracaoCampoObrigatorioResponse>(this.apiUrl, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getByTela(idTela: number): Observable<GetConfiguracaoCampoObrigatorioResponse> {
        return this.httpClient
            .get<GetConfiguracaoCampoObrigatorioResponse>(this.apiUrl + '/idTela/' + idTela, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(request: ConfiguracaoCampoObrigatorioRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
